import http from './http.js'

export const isLogin = () => {
  return new Promise((resolve, reject) => {
    if (this.localStorage.getItem('token')) {
      resolve(true)
    } else {
      reject(false)
    }
  })
}

// 获取图形验证码
export const getCaptcha = () => {
  return http.get('/tools/captcha').then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 获取手机验证码
export const getSmsCode = params => {
  return http.post('/ums/account/sendSmsCode', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 短信验证码登录
export const loginSms = params => {
  return http.post('/ums/account/loginSmsCode', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 获取个人信息
export const getInfo = params => {
  return http.get('/ums/account/info', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 获取个人绑定手机号
export const getPhone = params => {
  return http.get('/ums/account/bindPhone', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 绑定手机号
export const bindMobile = params => {
  return http.post('/ums/account/bindMobile', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 图片上传
export const uploadImg = params => {
  return http.postData('/tools/uploadImg', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 图片批量上传
export const uploadImgs = params => {
  return http.postData('/tools/uploadImgs', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 获取七牛云上传Token
export const getToken = () => {
  return http.get('/tools/upload/token').then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 获取阿里云上传sign
export const getSign = () => {
  return http.get('/tools/upload/sign').then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 支付宝支付
export const aliPay = params => {
  return http.post('/alipay/wappay', params).then(res => {
    return Promise.resolve(res)
    // if (res.code === 20000) {
    //     return Promise.resolve(res)
    // }
    // return Promise.reject(res)
  })
}

// 微信支付
export const wxPay = params => {
  return http.post('/wxpay/wappay', params).then(res => {
    if (res.code === 20000) {
      return Promise.resolve(res)
    }
    return Promise.reject(res)
  })
}

// 微信登陆
export const wxLogin = params => {
  return http.get('/ums/wx/authorize', params).then(res => {
    return Promise.resolve(res)
  })
}

// 微信jsapi
export const wxJsapi = params => {
  return http.get('/ums/wx/jsapi', params).then(res => {
    return Promise.resolve(res)
  })
}

// 选医生
export const chooseDoctor = params => {
  return http.get('/choose/doctor', params).then(res => {
    return Promise.resolve(res)
  })
}

// 选用户
export const chooseAccount = params => {
  return http.get('/choose/account', params).then(res => {
    return Promise.resolve(res)
  })
}



// WEBPACK FOOTER //
// ./src/api/commonApi.js